import { Mail, MapPin, Phone } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Heading, Text, YStack, Image, XStack, Anchor } from "tamagui";

import { homeServiceLogo } from "../../assets/images";
import { DividerLine } from "../../components/DividerLine";
import { IconContainer } from "../../components/IconContainer";

export const GeneralSettings = () => {
  const { t } = useTranslation();
  const location = "275 Old County Line Rd P Westerville, OH 43081";
  const phone = "(123) 456-7890";
  const email = "contact@homeserviceco.com";
  const companyName = "Home Service Company";

  return (
    <YStack gap="$4" width="100%" height="100%">
      <YStack gap="$2">
        <Text fontSize="$5.5">{t("sidebar.settings.settings")}</Text>
        <Heading fontSize="$8">{t("sidebar.settings.serviceContact")}</Heading>
      </YStack>
      <YStack
        gap="$3.5"
        backgroundColor="$transparentBorder"
        padding="$4"
        borderRadius="$4"
        width="100%"
        height="100%"
      >
        <Image
          source={{ uri: homeServiceLogo }}
          width={147}
          height={56}
          objectFit="contain"
        />
        <DividerLine />
        <Heading color="$white12" fontSize="$3" lineHeight="$3">
          {companyName}
        </Heading>
        <XStack alignItems="center" justifyContent="flex-start" gap="8px">
          <IconContainer>
            <MapPin size={20} />
          </IconContainer>
          <Text fontSize="$4" color="$white12">
            {location}
          </Text>
        </XStack>
        <XStack alignItems="center" justifyContent="flex-start" gap="8px">
          <IconContainer>
            <Phone size={20} />
          </IconContainer>
          <Anchor
            href={`tel:${phone}`}
            color="$hgPrimary"
            fontSize="$4"
            fontWeight="700"
          >
            {phone}
          </Anchor>
        </XStack>
        <XStack alignItems="center" justifyContent="flex-start" gap="8px">
          <IconContainer>
            <Mail size={20} />
          </IconContainer>
          <Anchor
            href={`mailto:${email}`}
            color="$hgPrimary"
            fontWeight="700"
            fontSize="$4"
            target="_blank"
            rel="noopener noreferrer"
          >
            {email}
          </Anchor>
        </XStack>
      </YStack>
    </YStack>
  );
};
export default GeneralSettings;
